<template>
    <v-tabs
        :value="selectedTab === -1 ? 1 : selectedTab"
        background-color="transparent"
        class="denser-tabs"
        slider-size="4"
        vertical
    >
        <v-tab
            v-for="tab in tabs"
            :key="tab.value"
            style="height: unset"
            class="px-3 py-2 border-lg main--text"
            @click="onNavTabClick(tab, $event)"
        >
            <span class="body-2 mr-auto">
                {{ tab.text }}
            </span>
            <v-icon :class="isTabSelected(tab.route.name) ? 'opacity-1' : 'opacity-0'">
                mdi-chevron-right
            </v-icon>
        </v-tab>
    </v-tabs>
</template>

<script>
import { computed } from "@vue/composition-api";
import { $t } from "@/i18n";
import router from "@/router";

export default {
    name: "SideNavigation",
    props: {
        tabs: {
            type: Array,
            required: true
        },
    },
    setup(props, ctx) {
        const currentRoute = computed(() => ctx.root._route.name);

        const isTabSelected = (name) => {
            return name === currentRoute.value
        }

        const selectedTab = computed(() => props.tabs.findIndex(tab => isTabSelected(tab.route.name)));

        const onNavTabClick = (tab) => {
            return router.push({ name: tab.route.name });
        };

        return {
            selectedTab,
            onNavTabClick,
            isTabSelected,
            currentRoute
        };
    }
};
</script>
<style scoped lang="scss">
.v-tab {
    &:before {
        border-radius: 8px;
    }

    .body-2 {
        text-transform: none;
    }

    &.v-tab--active {
        .body-2 {
            font-weight: 600;
        }

        &:before {
            opacity: 0.12;
        }
    }
}


</style>
